<div class="flex">
    <span class="title"><i [class]="'fa ' + icon" *ngIf="icon"></i>{{ title }}</span>
</div>
